import { render, staticRenderFns } from "./salaryEdit.vue?vue&type=template&id=6d38e3b6&scoped=true&"
import script from "./salaryEdit.vue?vue&type=script&lang=js&"
export * from "./salaryEdit.vue?vue&type=script&lang=js&"
import style0 from "./salaryEdit.vue?vue&type=style&index=0&lang=css&"
import style1 from "./salaryEdit.vue?vue&type=style&index=1&id=6d38e3b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d38e3b6",
  null
  
)

component.options.__file = "salaryEdit.vue"
export default component.exports